import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteMomentArguments {
  params: OpalApiRequestParams<'DeleteMomentV3'>
}

// The Moment Delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteMoment({
  params,
}: DeleteMomentArguments): Promise<null> {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
